export default __webpack_public_path__ + "images/flags/sk.png?7137895339b524d976764f31b85c668059dc68111dd714edf9b48d36f1a5da94";